// 地区与职能模块

//获取职能大类
function roleDivision() {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getmainjobfunc" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              resolve(jsonRes.msg);
            }
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取职能小类
function roleOffspring(id) {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getjobfunc", FuncCode: id },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              let list = jsonRes.msg;
              let sorts = [];
              list.forEach(l => {
                if (sorts.length == 0) {
                  sorts.push({ sortname: l.funcindex, children: [l.funcname] });
                } else {
                  let site = "";
                  let isExist = sorts.find((s, i) => {
                    if (s.sortname == l.funcindex) {
                      site = i;
                      return s;
                    }
                  });
                  if (!isExist) {
                    sorts.push({ sortname: l.funcindex, children: [l.funcname] });
                  } else {
                    sorts[site].children.push(l.funcname);
                  }
                }
              });
              resolve(sorts);
            }
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//根据code获取地区信息
function codeToInfor(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getarea", NationCode: code },
      dataType: "json",
      success: res => {
        if (res) {
          let data = JSON.parse(res);
          if (data.status == "ok") {
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取服务城市
function getServeCity() {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getservercity" },
      dataType: "json",
      success: res => {
        if (res) {
          let data = JSON.parse(res);
          if (data.status == "ok") {
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取所有省份
function provinces() {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getallprovince" },
      dataType: "json",
      success: res => {
        if (res) {
          const raw = `{"msg": ${res}}`;
          let data = JSON.parse(raw);
          resolve(data.msg);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取省份下的所有城市
function citys(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getallcity", NationCode: code },
      dataType: "json",
      success: res => {
        if (res) {
          const raw = `{"msg": ${res}}`;
          let data = JSON.parse(raw);
          resolve(data.msg);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取城市下的所有区县
function areas(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "get",
      url: APIPsn + '/Psninfo/GetInf',
      data: { pagename: "getallarea", NationCode: code },
      dataType: "json",
      success: res => {
        if (res) {
          const raw = `{"msg": ${res}}`;
          let data = JSON.parse(raw);
          resolve(data.msg);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//设置服务城市
function setServeCity(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bsetcity", nation: code },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? true : false);
      }
    });
  });
}

//删除服务城市
function delServeCity(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "del", userid: Cookies.get("userid-b"), pagename: "bsetcity", nation: code },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? true : false);
      }
    });
  });
}

export default {
  roleDivision,
  roleOffspring,
  codeToInfor,
  getServeCity,
  provinces,
  citys,
  areas,
  setServeCity,
  delServeCity
};
